import axios from 'axios'

const api = axios.create({ baseURL: '/api' })

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token')
  if (token) cfg.headers.Authorization = `Bearer ${token}`
  return cfg
})

api.interceptors.response.use(
  r => r.data,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(err)
  }
)

export const auth = {
  login: (username: string, password: string) =>
    api.post('/auth/login', { username, password }),
  me: () => api.get('/auth/me'),
}

export const home = {
  kpi: (d?: string) => api.get('/home/kpi', { params: d ? { d } : {} }),
  schedules: (week: string) => api.get('/home/schedules', { params: { week } }),
  todos: () => api.get('/home/todos'),
  createTodo: (data: any) => api.post('/home/todos', data),
  updateTodo: (id: number, data: any) => api.patch(`/home/todos/${id}`, data),
  deleteTodo: (id: number) => api.delete(`/home/todos/${id}`),
}

export const users = {
  list: () => api.get('/users'),
  create: (data: any) => api.post('/users', data),
  update: (id: number, data: any) => api.patch(`/users/${id}`, data),
  loginLogs: (params?: any) => api.get('/users/logs/login', { params }),
  usageLogs: (params?: any) => api.get('/users/logs/usage', { params }),
  modules: () => api.get('/users/modules'),
  permissions: (id: number) => api.get(`/users/${id}/permissions`),
  setPermissions: (id: number, granted: string[]) => api.put(`/users/${id}/permissions`, { granted }),
  myPermissions: () => api.get('/users/me/permissions'),
}

export const liveMonitor = {
  overview: (date?: string) => api.get('/matches/overview', { params: { date } }),
  matches: (params?: any) => api.get('/matches', { params }),
  reservations: (id: number) => api.get(`/matches/${id}/reservations`),
  live: (id: number) => api.get(`/matches/${id}/live`),
  result: (id: number) => api.get(`/matches/${id}/result`),
}

export const attendanceApi = {
  get: (week?: string) => api.get('/attendance/attendance', { params: { week } }),
}

export const dashboard = {
  expert: (days = 7) => api.get('/dashboard/expert/overview', { params: { days } }),
  recruit: (days = 30) => api.get('/dashboard/recruit/overview', { params: { days } }),
  plan: (days = 7) => api.get('/dashboard/plan/overview', { params: { days } }),
  bigr: (days = 30, threshold = 1000) =>
    api.get('/dashboard/bigr/overview', { params: { days, threshold } }),
  gmv: (days = 30) => api.get('/dashboard/gmv/overview', { params: { days } }),
}

export const dashboardTabs = {
  list: () => api.get('/dashboard-tabs'),
  create: (data: { name: string; url: string; owner?: string; description?: string }) => api.post('/dashboard-tabs', data),
  update: (id: number, data: any) => api.patch(`/dashboard-tabs/${id}`, data),
  remove: (id: number) => api.delete(`/dashboard-tabs/${id}`),
}

export const toolTabs = {
  list: () => api.get('/tool-tabs'),
  create: (data: { name: string; url: string; owner?: string; description?: string }) => api.post('/tool-tabs', data),
  update: (id: number, data: any) => api.patch(`/tool-tabs/${id}`, data),
  remove: (id: number) => api.delete(`/tool-tabs/${id}`),
}

export const opsBackends = {
  list: () => api.get('/ops-backends'),
  create: (data: { name: string; url: string; description?: string; open_mode?: string }) => api.post('/ops-backends', data),
  remove: (id: number) => api.delete(`/ops-backends/${id}`),
}

export default api
